<template>
  <div>
    <div class="header-content-height">
      <Header/>
      <router-view />
    </div>
    <Footer />

    <MessageModal />

  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

import MessageModal from './components/MessageModal.vue';

export default {
  components: {
    Header,
    Footer,
    MessageModal,

  },
};
</script>

<style lang="less">
@import "./assets/app.less";

html {
  background: white;
  font-family: 'sylfean';
}
.header-content-height {
  min-height: calc(100vh - 60px);
}

.d-border {
border: 1px solid pink
}
</style>
